import { AbstractFacade } from '@goparrot/common';
import { plainToClass } from 'class-transformer';
import deepmerge from 'deepmerge';
import { ReadUserDto } from '../generated-dto';
import { UserExposeGroup } from '../interface';
export class UserFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_USER,
                },
            },
            config,
        ]), interceptors);
    }
    async create(user) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/users/', user)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async createSSO(user) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/users/sso', user)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async authenticate(user) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/users/authenticate', user)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async findOne(uuid) {
        return plainToClass(ReadUserDto, (await this.client.get(`/api/v1/users/${encodeURIComponent(uuid)}`)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async delete(uuid) {
        await this.client.delete(`/api/v1/users/${uuid}`);
    }
    async list(criteria, hierarchyLevel) {
        return plainToClass(ReadUserDto, (await this.client.get('/api/v1/users/', { params: { ...criteria, hierarchyLevel } })).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async patch(uuid, data) {
        return plainToClass(ReadUserDto, (await this.client.patch(`/api/v1/users/${uuid}`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async invite(data) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/users/invite', data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async inviteConfirm(data) {
        return plainToClass(ReadUserDto, (await this.client.post(`/api/v1/users/invite-confirm`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async inviteFranchise(data) {
        return plainToClass(ReadUserDto, (await this.client.post('/api/v1/users/franchise/invite', data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async inviteInfoFranchise(emailValidationToken) {
        return (await this.client.get('/api/v1/users/franchise/invite-info', { params: { emailValidationToken } })).data;
    }
    async inviteFranchiseConfirm(data) {
        return plainToClass(ReadUserDto, (await this.client.post(`/api/v1/users/franchise/invite-confirm`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async franchiseConnectOrganization(uuid) {
        return (await this.client.post(`/api/v1/users/${encodeURIComponent(uuid)}/franchise/connect`)).data;
    }
    async franchiseConfirmOrganization(uuid, data) {
        return plainToClass(ReadUserDto, (await this.client.post(`/api/v1/users/${encodeURIComponent(uuid)}/franchise/confirm`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=UserFacade.js.map